/**
 * Navbar.js
 * Place in: src/components/Navbar.js
 *
 * Changes from original:
 *   - Removed: SERVICES, EXPERIENCE (now a home section), SKILLS, WHO AM I
 *   - Kept:    HOME, PROJECTS, BLOGS, ADMIN
 *
 * LOGO PLACEHOLDER:
 *   Currently uses bs_logo.png — replace with an SVG version at:
 *   src/imgs/bs_logo.svg  (SVG scales crisp at all sizes)
 *   Then update the import below to:  import Logo from "../imgs/bs_logo.svg";
 */

import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "../styles/Navbar.css";
import { FiMenu, FiSun, FiMoon } from "react-icons/fi";
import Logo from "../imgs/bs_logo.png"; /* [PLACEHOLDER] swap to .svg */
import { useTheme } from "../hooks/useTheme";

function Navbar() {
  const [expandNavbar, setExpandNavbar] = useState(false);
  const [isAdmin, setIsAdmin]           = useState(
    () => !!localStorage.getItem("token")
  );
  const location = useLocation();
  const { dark, toggle } = useTheme();

  /* Close mobile nav on route change */
  React.useEffect(() => {
    setExpandNavbar(false);
    setIsAdmin(!!localStorage.getItem("token"));
  }, [location]);

  const handleLogout = () => {
    localStorage.removeItem("token");
    setIsAdmin(false);
  };

  const isActive = (path) => location.pathname === path;

  return (
    <nav className={`navbar ${expandNavbar ? "expanded" : ""}`}>
      <div className="navbar-container">
        {/* Logo */}
        <Link to="/" className="logo-link">
          <img src={Logo} alt="Biko Sulu" className="nav-logo" />
        </Link>

        {/* Right side */}
        <div className="nav-elements">
          <div className="nav-controls">
            {/* Light/dark toggle */}
            <button
              className="nav-theme-toggle"
              onClick={toggle}
              aria-label="Toggle colour mode"
            >
              {dark
                ? <FiSun  size={16} />
                : <FiMoon size={16} />}
            </button>

            {/* Mobile hamburger */}
            <div className="toggleButton">
              <button
                onClick={() => setExpandNavbar((p) => !p)}
                aria-label="Toggle navigation"
              >
                <FiMenu size={22} />
              </button>
            </div>
          </div>

          {/* Links */}
          <div className={`links ${expandNavbar ? "open" : ""}`}>
            <Link to="/"         className={isActive("/")         ? "active" : ""}>HOME</Link>
            <Link to="/projects" className={isActive("/projects") ? "active" : ""}>PROJECTS</Link>
            <Link to="/blogs"    className={isActive("/blogs")    ? "active" : ""}>BLOGS</Link>

            {isAdmin && (
              <>
                <Link
                  to="/admin/dashboard"
                  className={isActive("/admin/dashboard") ? "active" : ""}
                >
                  ADMIN
                </Link>
                <button onClick={handleLogout} className="nav-logout">
                  LOGOUT
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;